const fungicideFilters = {
  sort_select: {
    type: 'select',
    list: [
      {
        name: 'name_a_z',
        message_key: 'name:asc',
      },
      {
        name: 'name_z_a',
        message_key: 'name:desc',
      },
      {
        name: 'company_a_z',
        message_key: 'asset_owner:asc',
      },
      {
        name: 'company_z_a',
        message_key: 'asset_owner:desc',
      },
    ],
  },
  extra_filter: [
    {
      section: 'asset_owner',
      type: 'radio',
      list: [
        {
          name: 'Basf',
          message_key: 'Basf',
        },
        {
          name: 'Agroimport do Brasil',
          message_key: 'Agroimport do Brasil',
        },
        {
          name: 'Adama',
          message_key: 'Adama',
        },
        {
          name: 'Tide do Brasil',
          message_key: 'Tide do Brasil',
        },
        {
          name: 'Iharabras',
          message_key: 'Iharabras',
        },
        {
          name: 'Corteva',
          message_key: 'Corteva',
        },
        {
          name: 'Albaugh Agro',
          message_key: 'Albaugh Agro',
        },
        {
          name: 'FMC',
          message_key: 'FMC',
        },
        {
          name: 'Nutrien Solu\u00e7\u00f5es Agr\u00edcolas',
          message_key: 'Nutrien Solu\u00e7\u00f5es Agr\u00edcolas',
        },
        {
          name: 'Syngenta',
          message_key: 'Syngenta',
        },
        {
          name: 'Sipcam',
          message_key: 'Sipcam',
        },
        {
          name: 'Cropchem',
          message_key: 'Cropchem',
        },
        {
          name: 'Nortox',
          message_key: 'Nortox',
        },
        {
          name: 'Sumitomo Chemical',
          message_key: 'Sumitomo Chemical',
        },
        {
          name: 'UPL',
          message_key: 'UPL',
        },
        {
          name: 'Bayer',
          message_key: 'Bayer',
        },
        {
          name: 'Oxiqu\u00edmica Agroci\u00eancia',
          message_key: 'Oxiqu\u00edmica Agroci\u00eancia',
        },
        {
          name: 'Gowan Company',
          message_key: 'Gowan Company',
        },
        {
          name: 'Isagro Brasil Comercio de Produtos Agroqu\u00edmicos',
          message_key: 'Isagro Brasil Comercio de Produtos Agroqu\u00edmicos',
        },
        {
          name: 'Oxon Brasil Defensivos Agr\u00edcolas',
          message_key: 'Oxon Brasil Defensivos Agr\u00edcolas',
        },
        {
          name: 'Sabero Organics Am\u00e9rica',
          message_key: 'Sabero Organics Am\u00e9rica',
        },
        {
          name: 'Tecnomyl',
          message_key: 'Tecnomyl',
        },
        {
          name: 'ALTA - America Latina Tecnologia Agr\u00edcola',
          message_key: 'ALTA - America Latina Tecnologia Agr\u00edcola',
        },
        {
          name: 'BR3',
          message_key: 'BR3',
        },
        {
          name: 'Prentiss Qu\u00edmica',
          message_key: 'Prentiss Qu\u00edmica',
        },
        {
          name: 'Proregistros Registros de Produtos',
          message_key: 'Proregistros Registros de Produtos',
        },
        {
          name: 'ISK Biosciences',
          message_key: 'ISK Biosciences',
        },
        {
          name: 'Sinon',
          message_key: 'Sinon',
        },
        {
          name: 'Rotam do Brasil Agroqu\u00edmica e Produtos Agr\u00edcolas',
          message_key:
            'Rotam do Brasil Agroqu\u00edmica e Produtos Agr\u00edcolas',
        },
        {
          name: 'Guapo',
          message_key: 'Guapo',
        },
        {
          name: 'Helm',
          message_key: 'Helm',
        },
        {
          name: 'Indofil Industries',
          message_key: 'Indofil Industries',
        },
        {
          name: 'Proquimur',
          message_key: 'Proquimur',
        },
        {
          name: 'Pilarquim BR Comercial',
          message_key: 'Pilarquim BR Comercial',
        },
        {
          name: 'AMVAC',
          message_key: 'AMVAC',
        },
        {
          name: 'Rainbow',
          message_key: 'Rainbow',
        },
        {
          name: 'Red Surcos do Brasil Com\u00e9rcio Agropecu\u00e1rio',
          message_key: 'Red Surcos do Brasil Com\u00e9rcio Agropecu\u00e1rio',
        },
        {
          name: 'Dow AgroSciences',
          message_key: 'Dow AgroSciences',
        },
        {
          name: 'Anasac',
          message_key: 'Anasac',
        },
        {
          name: 'Stockton - Agrimor do Brasil',
          message_key: 'Stockton - Agrimor do Brasil',
        },
        {
          name: 'Quimetal Produtos Quimicos',
          message_key: 'Quimetal Produtos Quimicos',
        },
        {
          name: 'Yonon Bioci\u00eancias e Defensivos Agr\u00edcolas',
          message_key: 'Yonon Bioci\u00eancias e Defensivos Agr\u00edcolas',
        },
        {
          name: 'Ouro Fino Qu\u00edmica',
          message_key: 'Ouro Fino Qu\u00edmica',
        },
        {
          name: 'Green Place Com\u00e9rcio e Distribui\u00e7\u00e3o',
          message_key: 'Green Place Com\u00e9rcio e Distribui\u00e7\u00e3o',
        },
        {
          name: 'Avgust Crop Protection',
          message_key: 'Avgust Crop Protection',
        },
        {
          name: 'Tradecorp do Brasil Com\u00e9rcio de insumos Agr\u00edcolas',
          message_key:
            'Tradecorp do Brasil Com\u00e9rcio de insumos Agr\u00edcolas',
        },
        {
          name: 'Vittia',
          message_key: 'Vittia',
        },
        {
          name: 'Globachem',
          message_key: 'Globachem',
        },
        {
          name: 'SM Agrocare',
          message_key: 'SM Agrocare',
        },
        {
          name: 'Bio Springer do Brasil Ind\u00fastria de Alimentos',
          message_key: 'Bio Springer do Brasil Ind\u00fastria de Alimentos',
        },
        {
          name: 'Ballagro Agro Tecnologia',
          message_key: 'Ballagro Agro Tecnologia',
        },
        {
          name: 'Genica Inova\u00e7\u00e3o Biotecnologica',
          message_key: 'Genica Inova\u00e7\u00e3o Biotecnologica',
        },
        {
          name: 'Koppert do Brasil Holding',
          message_key: 'Koppert do Brasil Holding',
        },
        {
          name: 'Proventis Lifescience Defensivos Agr\u00edcolas',
          message_key: 'Proventis Lifescience Defensivos Agr\u00edcolas',
        },
        {
          name: 'Simbiose',
          message_key: 'Simbiose',
        },
        {
          name: 'Mezfer BR Solu\u00e7\u00f5es Agr\u00edcolas',
          message_key: 'Mezfer BR Solu\u00e7\u00f5es Agr\u00edcolas',
        },
        {
          name: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
          message_key: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
        },
        {
          name: 'Agrivalle Brasil Industria e Comercio de Produtos Agricolas',
          message_key:
            'Agrivalle Brasil Industria e Comercio de Produtos Agricolas',
        },
        {
          name: 'Biota Innovations',
          message_key: 'Biota Innovations',
        },
        {
          name: 'Massen Produtos Biologicos',
          message_key: 'Massen Produtos Biologicos',
        },
        {
          name: 'Biocontrol Sistema de Controle Biol\u00f3gico',
          message_key: 'Biocontrol Sistema de Controle Biol\u00f3gico',
        },
        {
          name: 'Novozymes BioAg',
          message_key: 'Novozymes BioAg',
        },
        {
          name: 'Mitsui & Co',
          message_key: 'Mitsui & Co',
        },
        {
          name: 'Crystal Agro',
          message_key: 'Crystal Agro',
        },
        {
          name: 'Total Biotecnologia Industria e Comercio',
          message_key: 'Total Biotecnologia Industria e Comercio',
        },
        {
          name: 'AllierBrasil Agro',
          message_key: 'AllierBrasil Agro',
        },
        {
          name: 'Funguran Giulini',
          message_key: 'Funguran Giulini',
        },
        {
          name: 'Sharda do Brasil Com\u00e9rcio de Produtos Qu\u00edmicos e Agroqu\u00edmicos',
          message_key:
            'Sharda do Brasil Com\u00e9rcio de Produtos Qu\u00edmicos e Agroqu\u00edmicos',
        },
        {
          name: "CHD'S Agrochemicals",
          message_key: "CHD'S Agrochemicals",
        },
        {
          name: 'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
          message_key:
            'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
        },
        {
          name: 'CAC Quimica',
          message_key: 'CAC Quimica',
        },
        {
          name: 'Rizobacter',
          message_key: 'Rizobacter',
        },
        {
          name: 'Perterra Insumos Agropecu\u00e1rios',
          message_key: 'Perterra Insumos Agropecu\u00e1rios',
        },
        {
          name: 'TZ Biotec',
          message_key: 'TZ Biotec',
        },
        {
          name: 'Cooperativa Mista de Desenvolvimento do Agroneg\u00f3cio',
          message_key:
            'Cooperativa Mista de Desenvolvimento do Agroneg\u00f3cio',
        },
        {
          name: 'Syncrom Assessoria e Com\u00e9rcio de Produtos Agropecu\u00e1rios',
          message_key:
            'Syncrom Assessoria e Com\u00e9rcio de Produtos Agropecu\u00e1rios',
        },
        {
          name: 'Tagros Brasil Com\u00e9rcio de Produtos Qu\u00edmicos',
          message_key: 'Tagros Brasil Com\u00e9rcio de Produtos Qu\u00edmicos',
        },
      ],
    },
    {
      section: 'target',
      type: 'checkbox',
      list: [
        {
          name: 'soybean_powdery_mildew',
          message_key: 'soybean_powdery_mildew',
        },
        {
          name: 'soybean_cercospora_blight',
          message_key: 'soybean_cercospora_blight',
        },
        {
          name: 'soybean_septoria_leaf_spot',
          message_key: 'soybean_septoria_leaf_spot',
        },
        {
          name: 'soybean_target_spot',
          message_key: 'soybean_target_spot',
        },
        {
          name: 'soybean_anthracnosis',
          message_key: 'soybean_anthracnosis',
        },
        {
          name: 'soybean_asian_soybean_rust',
          message_key: 'soybean_asian_soybean_rust',
        },
        {
          name: 'soybean_white_mold',
          message_key: 'soybean_white_mold',
        },
        {
          name: 'soybean_aerial_web_blight',
          message_key: 'soybean_aerial_web_blight',
        },
      ],
    },
    {
      section: 'chemical_group',
      type: 'radio',
      list: [
        {
          name: 'Strobilurin',
          message_key: 'chemical_group.strobilurin',
        },
        {
          name: 'Triazole',
          message_key: 'chemical_group.triazole',
        },
        {
          name: 'Benzimidazole',
          message_key: 'chemical_group.benzimidazole',
        },
        {
          name: 'Phenylpyridinylamine',
          message_key: 'chemical_group.phenylpyridinylamine',
        },
        {
          name: 'Carboxamide',
          message_key: 'chemical_group.carboxamide',
        },
        {
          name: 'Dithiocarbamate',
          message_key: 'chemical_group.dithiocarbamate',
        },
        {
          name: 'Isophthalonitrile',
          message_key: 'chemical_group.isophthalonitrile',
        },
        {
          name: 'Inorganic',
          message_key: 'chemical_group.inorganic',
        },
        {
          name: 'Quaternary Ammonium',
          message_key: 'chemical_group.quaternary_ammonium',
        },
        {
          name: 'Triazolinthione',
          message_key: 'chemical_group.triazolinthione',
        },
        {
          name: 'Biological',
          message_key: 'chemical_group.biological',
        },
        {
          name: 'Anilinopyrimidine',
          message_key: 'chemical_group.anilinopyrimidine',
        },
        {
          name: 'Morpholine',
          message_key: 'chemical_group.morpholine',
        },
        {
          name: 'Others',
          message_key: 'chemical_group.others',
        },
        {
          name: 'Dicarboximide',
          message_key: 'chemical_group.dicarboximide',
        },
        {
          name: 'Phenylpyrrole',
          message_key: 'chemical_group.phenylpyrrole',
        },
        {
          name: 'Amino Pyrazolinones',
          message_key: 'chemical_group.amino_pyrazolinones',
        },
        {
          name: 'Phenyl Oxo Ethyl Thiophene Amide',
          message_key: 'chemical_group.phenyl_oxo_ethyl_thiophene_amide',
        },
        {
          name: 'Cyanoacetamide Oxime',
          message_key: 'chemical_group.cyanoacetamide_oxime',
        },
      ],
    },
    {
      section: 'active_ingredient',
      type: 'radio',
      list: [
        {
          name: 'Pyraclostrobin',
          message_key: 'active_ingredient.pyraclostrobin',
        },
        {
          name: 'Epoxiconazole',
          message_key: 'active_ingredient.epoxiconazole',
        },
        {
          name: 'Carbendazim',
          message_key: 'active_ingredient.carbendazim',
        },
        {
          name: 'Tebuconazole',
          message_key: 'active_ingredient.tebuconazole',
        },
        {
          name: 'Thiophanate-Methyl',
          message_key: 'active_ingredient.thiophanate_methyl',
        },
        {
          name: 'Fluazinam',
          message_key: 'active_ingredient.fluazinam',
        },
        {
          name: 'Cyproconazole',
          message_key: 'active_ingredient.cyproconazole',
        },
        {
          name: 'Picoxystrobin',
          message_key: 'active_ingredient.picoxystrobin',
        },
        {
          name: 'Kresoxim-Methyl',
          message_key: 'active_ingredient.kresoxim_methyl',
        },
        {
          name: 'Fluxapyroxad',
          message_key: 'active_ingredient.fluxapyroxad',
        },
        {
          name: 'Azoxystrobin',
          message_key: 'active_ingredient.azoxystrobin',
        },
        {
          name: 'Flutriafol',
          message_key: 'active_ingredient.flutriafol',
        },
        {
          name: 'Mancozeb',
          message_key: 'active_ingredient.mancozeb',
        },
        {
          name: 'Chlorothalonil',
          message_key: 'active_ingredient.chlorothalonil',
        },
        {
          name: 'Metconazole',
          message_key: 'active_ingredient.metconazole',
        },
        {
          name: 'Copper Oxychloride',
          message_key: 'active_ingredient.copper_oxychloride',
        },
        {
          name: 'Difenoconazole',
          message_key: 'active_ingredient.difenoconazole',
        },
        {
          name: 'Tetraconazole',
          message_key: 'active_ingredient.tetraconazole',
        },
        {
          name: 'Benzovindiflupyr',
          message_key: 'active_ingredient.benzovindiflupyr',
        },
        {
          name: 'Benzalkonium Chloride',
          message_key: 'active_ingredient.benzalkonium_chloride',
        },
        {
          name: 'Prothioconazole',
          message_key: 'active_ingredient.prothioconazole',
        },
        {
          name: 'Trifloxystrobin',
          message_key: 'active_ingredient.trifloxystrobin',
        },
        {
          name: 'Metominostrobin',
          message_key: 'active_ingredient.metominostrobin',
        },
        {
          name: 'Propiconazole',
          message_key: 'active_ingredient.propiconazole',
        },
        {
          name: 'Bacillus Subtilis',
          message_key: 'active_ingredient.bacillus_subtilis',
        },
        {
          name: 'Myclobutanil',
          message_key: 'active_ingredient.myclobutanil',
        },
        {
          name: 'Cyprodinil',
          message_key: 'active_ingredient.cyprodinil',
        },
        {
          name: 'Fenpropimorph',
          message_key: 'active_ingredient.fenpropimorph',
        },
        {
          name: 'Bixafen',
          message_key: 'active_ingredient.bixafen',
        },
        {
          name: 'Sulfur',
          message_key: 'active_ingredient.sulfur',
        },
        {
          name: 'Bromuconazole',
          message_key: 'active_ingredient.bromuconazole',
        },
        {
          name: 'Others',
          message_key: 'active_ingredient.others',
        },
        {
          name: 'Dimoxystrobin',
          message_key: 'active_ingredient.dimoxystrobin',
        },
        {
          name: 'Boscalid',
          message_key: 'active_ingredient.boscalid',
        },
        {
          name: 'Procymidone',
          message_key: 'active_ingredient.procymidone',
        },
        {
          name: 'Metiram',
          message_key: 'active_ingredient.metiram',
        },
        {
          name: 'Bacillus Velezensis',
          message_key: 'active_ingredient.bacillus_velezensis',
        },
        {
          name: 'Cerevisane',
          message_key: 'active_ingredient.cerevisane',
        },
        {
          name: 'Trichoderma Harzianum',
          message_key: 'active_ingredient.trichoderma_harzianum',
        },
        {
          name: 'Trichoderma Asperellum',
          message_key: 'active_ingredient.trichoderma_asperellum',
        },
        {
          name: 'Bacillus Amyloliquefaciens',
          message_key: 'active_ingredient.bacillus_amyloliquefaciens',
        },
        {
          name: 'Fludioxonil',
          message_key: 'active_ingredient.fludioxonil',
        },
        {
          name: 'Iprodione',
          message_key: 'active_ingredient.iprodione',
        },
        {
          name: 'Fluopyram',
          message_key: 'active_ingredient.fluopyram',
        },
        {
          name: 'Mefentrifluconazole',
          message_key: 'active_ingredient.mefentrifluconazole',
        },
        {
          name: 'Bacillus Pumilus',
          message_key: 'active_ingredient.bacillus_pumilus',
        },
        {
          name: 'Inpyrfluxam',
          message_key: 'active_ingredient.inpyrfluxam',
        },
        {
          name: 'Copper Hydroxide',
          message_key: 'active_ingredient.copper_hydroxide',
        },
        {
          name: 'Fenpyrazamine',
          message_key: 'active_ingredient.fenpyrazamine',
        },
        {
          name: 'Isofetamid',
          message_key: 'active_ingredient.isofetamid',
        },
        {
          name: 'Cymoxanil',
          message_key: 'active_ingredient.cymoxanil',
        },
        {
          name: 'Trichoderma Afroharzianum',
          message_key: 'active_ingredient.trichoderma_afroharzianum',
        },
        {
          name: 'Pydiflumetofen',
          message_key: 'active_ingredient.pydiflumetofen',
        },
        {
          name: 'Fluindapyr',
          message_key: 'active_ingredient.fluindapyr',
        },
      ],
    },
  ],
}

const varietyFilters = {
  sort_select: {
    type: 'select',
    list: [
      {
        name: 'name_a_z',
        message_key: 'name:asc',
      },
      {
        name: 'name_z_a',
        message_key: 'name:desc',
      },
      {
        name: 'company_a_z',
        message_key: 'asset_owner:asc',
      },
      {
        name: 'company_z_a',
        message_key: 'asset_owner:desc',
      },
      {
        name: 'gmr_less_greater',
        message_key: 'gmr:asc',
      },
      {
        name: 'gmr_greater_less',
        message_key: 'gmr:desc',
      },
    ],
  },
  crop_filter: {
    type: 'radio',
    list: ['soybean', 'wheat'],
  },
  extra_filter: [
    {
      section: 'gmr',
      type: 'slider',
      min: '4.1',
      max: '8.3',
    },
    {
      section: 'asset_owner',
      type: 'radio',
      list: [
        {
          name: 'Agr\u00e1ria Sementes',
          message_key: 'Agr\u00e1ria Sementes',
        },
        {
          name: 'Agroeste',
          message_key: 'Agroeste',
        },
        {
          name: 'Avanti Seeds',
          message_key: 'Avanti Seeds',
        },
        {
          name: 'Basf',
          message_key: 'Basf',
        },
        {
          name: 'Baup Semillas',
          message_key: 'Baup Semillas',
        },
        {
          name: 'Bayer',
          message_key: 'Bayer',
        },
        {
          name: 'Brasmax',
          message_key: 'Brasmax',
        },
        {
          name: 'Brevant',
          message_key: 'Brevant',
        },
        {
          name: 'Centro Educacional Integrado Ltda - CEI',
          message_key: 'Centro Educacional Integrado Ltda - CEI',
        },
        {
          name: 'Coodetec',
          message_key: 'Coodetec',
        },
        {
          name: 'Cordius',
          message_key: 'Cordius',
        },
        {
          name: 'Corteva',
          message_key: 'Corteva',
        },
        {
          name: 'Credenz',
          message_key: 'Credenz',
        },
        {
          name: 'Don Mario',
          message_key: 'Don Mario',
        },
        {
          name: 'Dow AgroSciences',
          message_key: 'Dow AgroSciences',
        },
        {
          name: 'Embrapa',
          message_key: 'Embrapa',
        },
        {
          name: 'Ft Sementes',
          message_key: 'Ft Sementes',
        },
        {
          name: 'Funda\u00e7\u00e3o Pr\u00f3-Sementes',
          message_key: 'Funda\u00e7\u00e3o Pr\u00f3-Sementes',
        },
        {
          name: 'Fundacep',
          message_key: 'Fundacep',
        },
        {
          name: 'Gmax Gen\u00e9tica Ga\u00facha',
          message_key: 'Gmax Gen\u00e9tica Ga\u00facha',
        },
        {
          name: 'Golden Harvest',
          message_key: 'Golden Harvest',
        },
        {
          name: 'Ho Gen\u00e9tica',
          message_key: 'Ho Gen\u00e9tica',
        },
        {
          name: 'Intellicrops',
          message_key: 'Intellicrops',
        },
        {
          name: 'Kws Sementes',
          message_key: 'Kws Sementes',
        },
        {
          name: 'Lg Sementes',
          message_key: 'Lg Sementes',
        },
        {
          name: 'Monsoy',
          message_key: 'Monsoy',
        },
        {
          name: 'Neogen',
          message_key: 'Neogen',
        },
        {
          name: 'Nidera',
          message_key: 'Nidera',
        },
        {
          name: 'Pioneer',
          message_key: 'Pioneer',
        },
        {
          name: 'Sementes Roos',
          message_key: 'Sementes Roos',
        },
        {
          name: 'Sempre Sementes',
          message_key: 'Sempre Sementes',
        },
        {
          name: 'Soytech',
          message_key: 'Soytech',
        },
        {
          name: 'Syngenta',
          message_key: 'Syngenta',
        },
        {
          name: 'Tmg',
          message_key: 'Tmg',
        },
      ],
    },
    {
      section: 'sowing_time',
      type: 'date_period',
      range: {
        preferred_sowing_start: '2025-09-01T00:00:00.000Z',
        preferred_sowing_end: '2025-12-31T00:00:00.000Z',
      },
    },
  ],
}

const nematicideFilters = {
  sort_select: {
    type: 'select',
    list: [
      {
        name: 'name_a_z',
        message_key: 'name:asc',
      },
      {
        name: 'name_z_a',
        message_key: 'name:desc',
      },
      {
        name: 'company_a_z',
        message_key: 'asset_owner:asc',
      },
      {
        name: 'company_z_a',
        message_key: 'asset_owner:desc',
      },
    ],
  },
  extra_filter: [
    {
      section: 'asset_owner',
      type: 'radio',
      list: [
        {
          name: 'Koppert do Brasil Holding',
          message_key: 'Koppert do Brasil Holding',
        },
        {
          name: 'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
          message_key:
            'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
        },
      ],
    },
    {
      section: 'target',
      type: 'checkbox',
      list: [
        {
          name: 'Pratylenchus zeae',
          message_key: 'nematode.pratylenchus_zeae',
        },
        {
          name: 'Heterodera glycines',
          message_key: 'nematode.heterodera_glycines',
        },
        {
          name: 'Meloidogyne incognita',
          message_key: 'nematode.meloidogyne_incognita',
        },
        {
          name: 'Meloidogyne javanica',
          message_key: 'nematode.meloidogyne_javanica',
        },
        {
          name: 'Pratylenchus brachyurus',
          message_key: 'nematode.pratylenchus_brachyurus',
        },
      ],
    },
    {
      section: 'chemical_group',
      type: 'radio',
      list: [
        {
          name: 'Biological',
          message_key: 'chemical_group.biological',
        },
      ],
    },
    {
      section: 'active_ingredient',
      type: 'radio',
      list: [
        {
          name: 'Trichoderma Harzianum',
          message_key: 'active_ingredient.trichoderma_harzianum',
        },
        {
          name: 'Bacillus Subtilis',
          message_key: 'active_ingredient.bacillus_subtilis',
        },
      ],
    },
  ],
}

export { fungicideFilters, nematicideFilters, varietyFilters }
